/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { PageLink, PageTitle, useLayout } from '../../../_payairo/layout/core'
import { axiosClientAuth } from '../../utils'
import { useAuth } from '../../modules/auth'
import TableWidgetTransactions from '../../../_payairo/partials/widgets/_new/tables/TableWidgetTransactions'
import TableWidgetAdminActivity from '../../../_payairo/partials/widgets/_new/tables/TableWidgetActivity'
import CardsDashboardMain from '../../../_payairo/partials/widgets/_new/cards/CardsDashboardMain'
import CardsDashboardTickets, { TicketCountData } from '../../../_payairo/partials/widgets/_new/cards/CardsDashboardTickets'
import { CardsDashboardTransactions } from '../../../_payairo/partials/widgets/_new/cards/CardsDashboardTransactions'
import moment from 'moment'

const initialData = {
  userData: {
    user_count: {
      total_users: 0,
      active_users: 0,
      recent_users: 0,
    }
  },
  ticketStats: {
    ticket_count: {
      all_tickets: 0,
      open_tickets: 0,
      inprocess_tickets: 0,
      closed_tickets: 0,
    }
  },
  transactionData: {
    transaction_stats: {
      fiat_count: 0,
      fiat_amount: 0,
      crypto_count: 0,
      crypto_amount: 0,
      total_withdrawal_amount: 0,
    }
  },
  recentActivities: [],
  recentTransactions: [],
}

const DashboardPage: FC = () => {
  const [dashboardData, setDashboardData] = useState(initialData);
  const { showLoader, hideLoader } = useLayout()
  const { currentUser, auth } = useAuth()
  
  useEffect(() => {
    showLoader()
    
    // Get role and userId for role-based API calls
    const role = currentUser?.role || auth?.role || currentUser?.user_type
    const userId = currentUser?.id || auth?.userId
    
    // Determine API endpoint based on role
    let apiEndpoint = "auth/useradmin/dashboard/"
    
    if (role === 'CUSTOMER_SUPPORT' || role === 'CustomerSupport') {
      apiEndpoint = "auth/customer-support/dashboard/"
    } else if (
      role === 'SUPER_ADMIN' ||
      role === 'SuperAdmin' ||
      role === 'Admin' ||
      role === 'Developer'
    ) {
      apiEndpoint = "auth/useradmin/dashboard/"
    }
    
    // Add userId as query param if available and needed
    const apiUrl = userId ? `${apiEndpoint}?user_id=${userId}` : apiEndpoint
    
    console.log('Fetching dashboard data for role:', role, 'userId:', userId, 'endpoint:', apiUrl)
    
    axiosClientAuth
      .get(apiUrl)
      .then((res) => {
        const api = res.data?.data || {};

        setDashboardData({
          userData: {
            user_count: {
              total_users: api.users?.total_users ?? 0,
              active_users: api.users?.active_users ?? 0,
              recent_users: api.users?.this_week_new_users_count ?? 0,
            }
          },

          ticketStats: {
            ticket_count: {
              all_tickets: api.support_tickets?.total_support_tickets ?? 0,
              open_tickets: api.support_tickets?.open_support_tickets ?? 0,
              inprocess_tickets: api.support_tickets?.inprocess_support_tickets ?? api.support_tickets?.in_process_support_tickets ?? 0,
              closed_tickets: api.support_tickets?.closed_support_tickets ?? 0,
            }
          },

          transactionData: {
            transaction_stats: {
              fiat_count: api.transactions?.success_transactions ?? 0,
              fiat_amount: api.transactions?.total_transaction_amount ?? 0,

              crypto_count: api.trades?.total_trades ?? 0,
              crypto_amount: api.trades?.pending_trades ?? 0,


              total_withdrawal_amount:
                api.transactions?.withdraw_amount ?? 0,
            }
          },

          recentActivities: (api.recent_activity || []).map((item) => ({
            actionType: item.title ?? "",
            description: item.description ?? "",
            timestamp: moment(item.timestamp).format("DD MMM YYYY, hh:mm A") ?? "",
            icon: "ki-information",
            color: item.status === "pending" ? "warning" : "success",
          })),

          recentTransactions: (api.transactions.recent_transactions || []).map((item) => ({
            id: item.id ?? "",
            sender_username: item.sender_username ?? "",
            sender_email: item.sender_email ?? "",
            recipient_username: item.recipient_username ?? "",
            recipient_email: item.recipient_email ?? "",
            type: item.type ?? "",
            amount: item.amount ?? 0,
            currency_symbol: item.currency ?? "$",
            status: item.status ?? "",
            created_at: item.timestamp ?? "",
          })),
        });
      })
      .catch((err) => {
        console.log(err);
        setDashboardData(initialData);
      }).finally(() => hideLoader());
  }, [currentUser?.role, currentUser?.id, auth?.role, auth?.userId]);

  return (
    <>

      <div className='row g-5 gx-xl-10 mb-5 mb-xl-10'>

        <div className='col-xl-6'>
          <div className='row g-5 gx-xl-10 mb-5 mb-xl-10 w-100'>

            <div className="col-xl-3 w-50 h-100">
              <CardsDashboardMain data={dashboardData.userData} />
            </div>
            <div className='col-xl-3 w-50 h-100'>
              <CardsDashboardTickets data={dashboardData.ticketStats} />
            </div>
          </div>
          <div className='col-xl-6 w-100'>

            <CardsDashboardTransactions data={dashboardData.transactionData}
            />
          </div>
        </div>
        <TableWidgetAdminActivity activities={dashboardData.recentActivities} />
      </div>




      <div className='row gy-5 g-xl-10'>

        <div className='col-12'>
          <TableWidgetTransactions data={dashboardData.recentTransactions} />
        </div>
      </div>
    </>
  )
}

const myBreadCrumbs: Array<PageLink> = [
  {
    title: 'Home',
    path: '/dashboard',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const DashboardWrapper: FC = () => {
  const intl = useIntl()
  const { setRightTolbar } = useLayout()

  useEffect(() => {
    setRightTolbar('dashboard')
  }, [])

  return (
    <>
      <PageTitle breadcrumbs={myBreadCrumbs}>
        {intl.formatMessage({ id: 'MENU.DASHBOARD' })}
      </PageTitle>

      <DashboardPage />
    </>
  )
}

export { DashboardWrapper }
